import { reducerWithInitialState } from "typescript-fsa-reducers";
import { getClientConfig } from "./actions";
import { ClientMetadataState } from "./types";

const initialState: ClientMetadataState = {};

const clientMetadataReducer = reducerWithInitialState<
  Readonly<ClientMetadataState>
>(initialState).case(getClientConfig.async.done, (state, { result }) => {
  return result;
});

export default clientMetadataReducer;



// WEBPACK FOOTER //
// ./src/clientMetadata/reducer.ts